import React from 'react';
import './StatsCard.css';

const StatsCard = ({ title, value, subtitle, icon, color, trend }) => {
  return (
    <div className={`stats-card stats-card-${color}`}>
      <div className="stats-card-header">
        <div className="stats-card-info">
          <p className="stats-card-title">{title}</p>
          <h3 className="stats-card-value">{value}</h3>
          <p className="stats-card-subtitle">{subtitle}</p>
        </div>
        <div className={`stats-card-icon stats-icon-${color}`}>
          <i className={icon}></i>
        </div>
      </div>
      {trend && (
        <div className="stats-card-footer">
          <span className="stats-trend">{trend}</span>
        </div>
      )}
    </div>
  );
};

export default StatsCard;

